<template>
  <v-hover v-slot="{ hover }">
    <div
      @contextmenu.prevent="onShowMenu"
      aspect-ratio="1"
      :class="`game-content ${hover && 'tw-scale-110 tw-z-50 drop-shadow'} tw-min-h-[183px] tw-h-full tw-relative`"
    >
      <v-btn v-if="$auth.user" @click.stop="addFavorite" icon class="tw-absolute tw-top-2 tw-right-2 tw-z-20"
        ><v-icon :color="`${favorite ? '#d4af37' : 'white'}`">mdi-heart</v-icon></v-btn
      >
      <v-scale-transition>
        <v-img
          position="top center"
          class="tw-flex tw-items-end tw-rounded-md"
          :src="image"
          height="100%"
          transition="scroll-y-reverse-transition"
        >
          <template v-slot:placeholder>
            <v-sheet>
              <v-skeleton-loader class="mx-auto" max-width="300" type="card"></v-skeleton-loader>
            </v-sheet>
          </template>
          <div
            :class="`background-overlay tw-z-0 py-2 px-2 background-info ${hover ? 'tw-opacity-100' : ' tw-opacity-0'}`"
          ></div>
          <div :class="`game-title tw-text-white ${hover ? 'tw-opacity-100' : ' tw-opacity-0'}`">{{ game.name }}</div>
        </v-img>
      </v-scale-transition>
      <v-fade-transition>
        <div class="hover-play" v-if="hover">
          <div class="tw-flex tw-items-center tw-justify-center tw-h-full">
            <v-img :src="require('@/assets/images/play.svg')"></v-img>
          </div>
        </div>
      </v-fade-transition>

      <div>
        <v-row justify="space-around">
          <v-col cols="12">
            <div>
              <v-menu
                v-model="showMenu"
                :position-x="x"
                :position-y="y"
                absolute
                offset-y
                :close-on-content-click="false"
              >
                <v-card class="tw-flex tw-items-center tw-justify-center" color="#031b41">
                  <v-card-text class="tw-pb-4">
                    <div class="tw-grid tw-grid-cols-5 tw-gap-y-2">
                      <div class="tw-col-span-3 tw-text-center tw-flex tw-items-center">Game Sort Number</div>
                      <div class="tw-col-span-2">
                        <v-text-field
                          hide-details
                          v-model="gameSort"
                          solo
                          background-color="#0a356b"
                          type="number"
                          style="width: 120px"
                          ref="test"
                          @click="$event.target.select()"
                          v-on:keyup.enter="saveSortOrder"
                        ></v-text-field>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-menu>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-hover>
</template>

<script>
import { mapActions } from "vuex";
import { gameApi } from "../api";
export default {
  props: ["game", "type"],
  data: () => ({
    image: null,
    favorite: false,
    showMenu: false,
    x: 0,
    y: 0,
    gameSort: 0,
  }),
  watch: {
    async game() {
      await this.getImage();
      this.gameSort = this.game[this.sortName];
    },
    "game.is_favorite": function () {
      this.favorite = this.game.is_favorite;
    },
  },
  async mounted() {
    this.favorite = this.game.is_favorite;
    this.gameSort = this.game[this.sortName];
    await this.getImage();
  },
  computed: {
    sortName() {
      let sortName = null;
      if (this.type == "live-casino") {
        sortName = "live_sort_order";
      } else if (this.type == "slots") {
        sortName = "sort_order";
      } else if (this.type == "home") {
        sortName = "home_sort_order";
      } else if (this.currentProviders.length == 1) {
        sortName = "provider_sort_order";
      }
      return sortName;
    },
    currentProviders() {
      const providers = this.$route.query.providers || "";
      return providers
        .split(",")
        .map((provider) => {
          return provider;
        })
        .filter((provider) => !!provider);
    },
  },
  methods: {
    ...mapActions("game", ["getGameImage", "sortGames"]),
    onShowMenu(e) {
      e.preventDefault();
      if (typeof this.$auth.user == "undefined" || this.$auth.user.type != "admin") {
        return;
      }
      if (!this.sortName || ["favorites", "recent-games"].includes(this.type)) return;
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    async getImage() {
      if (this.game.main_provider == "Slotegator") {
        const response = await this.getGameImage(this.game.image);
        this.image = "data:image/bmp;base64," + response.image;
      } else {
        this.image = this.game.image;
      }
    },
    async addFavorite() {
      try {
        const response = await gameApi.post(`/games/${this.game.uuid}/favorites`, {
          favorite: !this.favorite,
        });
        if (response.data.success) {
          if (this.type == "favorites") {
            this.$emit("removeItem", this.game);
          } else this.favorite = response.data.added;
        }
      } catch (error) {
        console.log(error);
      }
    },

    saveSortOrder: async function () {
      if (typeof this.$auth.user == "undefined" || this.$auth.user.type != "admin") {
        return;
      }

      await this.sortGames([{ ...this.game, [this.sortName]: this.gameSort }]);
      // this.$emit("reload");
      this.showMenu = false;
    },
  },
};
</script>

<style scoped>
.game-content {
  @apply tw-transition-all tw-duration-700 tw-ease-out tw-relative;
}
.hover-play {
  @apply tw-cursor-pointer tw-absolute tw-bg-gradient-to-t hover:tw-from-[rgba(0,0,0,.2)] tw-to-transparent tw-inset-0 tw-z-10;
}
.background-overlay {
  @apply tw-text-white tw-text-sm  tw-flex  tw-justify-between  tw-items-center tw-transition-all tw-duration-500 tw-absolute tw-bottom-0 tw-h-8 tw-w-full;
}
.game-title {
  @apply tw-antialiased tw-pb-1 tw-opacity-100 tw-text-left tw-px-2 tw-absolute tw-bottom-0;
}
.drop-shadow {
  box-shadow: 0 0 30px black;
}
.background-info {
  background: rgb(0, 0, 0);
  background: linear-gradient(-90deg, #031b41aa 0%, #031b41aa 100%);
  opacity: 1;
}

.background-info.opacity {
  opacity: 1;
}
</style>
